import { CustomLink } from '@/components/custom-link';
import classNames from 'classnames';
import styles from './card.module.scss';

export const WithLink = ({
  href,
  className,
  children,
  backgroundColour,
}: {
  href?: string;
  className: string;
  children: React.ReactNode;
  backgroundColour?: string;
}) =>
  href ? (
    <CustomLink
      href={href}
      className={classNames(styles[`card--${backgroundColour}`], className)}
      data-testid="card-id"
    >
      {children}
    </CustomLink>
  ) : (
    <div
      className={classNames(styles[`card--${backgroundColour}`], className)}
      data-testid="card-id"
    >
      {children}
    </div>
  );
